import { FormikProps, useFormik } from "formik";
import { ReactNode } from "react";
import Flex from "../../../../../../components/Flex";
import ReadOnlyFields from "../../../../../../components/ReadOnlyFields";
import { ScrollArea } from "../../../../../../components/ScrollBar";
import { RosTemplate } from "../../../../../../services";
import EmailForm from "../EmailForm";
import SmsForm from "../SmsForm";
import TemplateBasicReqFields from "../components/TemplateBasicReqFields";
import Micro from "../template-forms/Micro";
import SideSheetDrawer from "../../../../../../components/SidesheetDrawer";
import { DisclosureHost } from "../../../../../../hooks/use-disclosure";
import { IconButton } from "@mui/material";
import ModeOutlinedIcon from "@mui/icons-material/ModeOutlined";
import HomeCareRosForm from "../home-care-ros/HomeCareRosForm";
import PeRosForm from "../template-forms/pe-template/PeRosForm";
import CarePlanForm from "../template-forms/care-plan/CarePlanForm";
import { TEMPLATE_VALIDATION_SCHEMA } from "../template-constant";

/**
 *
 * @returns preview template
 * @author [Rajkumar rathod]
 */

const NewTemplatePreview = ({
  preFillSchema,
  disClosureHost,
  onEdit,
}: {
  preFillSchema: RosTemplate;
  disClosureHost: DisclosureHost;
  onEdit?: (formik: FormikProps<RosTemplate>) => void;
}) => {
  const formik = useFormik({
    initialValues: preFillSchema || {},
    validationSchema: TEMPLATE_VALIDATION_SCHEMA,
    onSubmit: () => {},
    enableReinitialize: true,
  });

  const ActiveFormMapper: Record<string, ReactNode> = {
    EMAIL: <EmailForm formik={formik} disabled />,
    SMS: <SmsForm formik={formik} disabled />,
    PHYSICAL: <PeRosForm formik={formik} disabled />,
    MACROS: <Micro formik={formik} disabled />,
    ROS: <PeRosForm formik={formik} disabled />,
    HOME_CARE_ROS: <HomeCareRosForm formik={formik} disabled />,
    HOME_CARE_PE: <HomeCareRosForm formik={formik} disabled />,
    CARE_PLAN: <CarePlanForm formik={formik} disabled />,
  };

  return (
    <SideSheetDrawer
      title={"Preview"}
      open={disClosureHost.opened}
      onClose={disClosureHost.close}
      endIcon={
        <IconButton onClick={() => onEdit?.(formik)}>
          <ModeOutlinedIcon />
        </IconButton>
      }
      w={"44vw"}
    >
      <ReadOnlyFields>
        <Flex flexDirection={"column"}>
          <TemplateBasicReqFields formik={formik} readOnly={!!preFillSchema} />

          <ScrollArea
            width={"100%"}
            height={`calc(100vh - ${formik.isValid ? "250px" : "320px"})`}
          >
            {/* all active form on basis of type */}
            {formik.values?.templateTypes ? (
              ActiveFormMapper[formik.values?.templateTypes]
            ) : (
              <></>
            )}
          </ScrollArea>
        </Flex>
      </ReadOnlyFields>
    </SideSheetDrawer>
  );
};

export default NewTemplatePreview;
